<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
</script>

<script lang="ts">
	import type { TextSelectorConfig } from '$lib/config';
	import { onMount } from 'svelte';
	import FormGroup from '../sub_components/FormGroup.svelte';
	import { validateCity } from './Address2';

	export const InstanceID = count;
	count += 1;
	export let Value: string = '';
	export let Config: TextSelectorConfig;
	export let ReadOnly: boolean = false;
	export let Disabled: boolean = false;
	let choice_els: { [key: number]: HTMLInputElement } = {};

	let ErrorEl: HTMLElement;
	export let ErrorMsg = Config.Required ? Config.EmptyMsg ?? 'Required field' : 'Invalid selection';
	console.log(Config);

	export function appendData(formData: FormData) {
		formData.append(Config.DBCol, Value);
	}
	export async function validate() {
		if (Config.Required && Value === '') {
			ErrorEl.style.display = 'block';
			return false;
		} else {
			ErrorEl.style.display = 'none';
			return true;
		}
	}
	onMount(async () => {
		console.log('Loading TextSelector; Config:', Config);
	});
	function onChange(e: Event) {
		//Update Value
		if (Config.MultiSelect) {
			let selections = [];
			for (let choice of Config.Choices) {
				if (choice_els[choice.Value].checked) {
					selections.push(choice.Value);
				}
			}
			Value = selections.join(',');
		} else {
			for (let choice of Config.Choices) {
				if (choice_els[choice.Value].checked) {
					Value = choice.Value;
					break;
				}
			}
		}
	}
	function onBlur(e: Event) {
		if (Value === '' && Config.Required) {
			console.log('Value;', Value);
			//Add show-comp-error class
			parentEl.classList.add('show-comp-error');
		} else {
			parentEl.classList.remove('show-comp-error');
		}
	}
	function onFocus(e: Event) {
		parentEl.classList.remove('show-comp-error');
	}
	export function focus() {
		choice_els[Config.Choices[0].Value].focus();
	}
	let spacerEl: HTMLDivElement;
	let parentEl: HTMLDivElement;
</script>

<FormGroup {Config} style="padding-bottom: 7px;">
	<div class="comp-title">{Config.Title}</div>
	<div id="TextSelector_{Config.DBCol}_form-outline" class="form-outline" bind:this={parentEl}>
		<div class="custom-select-container">
			{#each Config.Choices as choice, i}
				<label class="custom-select">
					<input
						type={Config.MultiSelect ? 'checkbox' : 'radio'}
						id="TextSelector_{Config.DBCol}_{i}"
						class="form-check-input"
						name={Config.DBCol ? Config.DBCol + '_' + Config.DBCol : Config.DBCol}
						on:change={onChange}
						on:blur={onBlur}
						on:focus={onFocus}
						bind:this={choice_els[choice.Value]}
						value={choice.Value}
						disabled={Disabled}
						readonly={ReadOnly}
					/>
					<span class:checkbox={Config.MultiSelect} class:radio={!Config.MultiSelect} />
					{choice.Text}</label
				>
			{/each}
		</div>
		<div class="invalid-tooltip" id="TextSelector_{Config.DBCol}Error" bind:this={ErrorEl}>
			{ErrorMsg}
		</div>
	</div>
	<div bind:this={spacerEl} class="msg-spacer" />
</FormGroup>
